module.exports = __webpack_public_path__ + "static/media/slide1.cdc6b22a.jpg";